import { defineComponent } from "vue";

export default defineComponent({
  name: "Devices",
  props: {},
  components: {}
  // setup(props) {},
});
